import { type ForwardedRef, forwardRef, useState } from 'react';
import { InputNumber, Button } from 'antd';
import classes from './index.module.scss';

import type { InputNumberProps } from 'antd/es/input-number';
import { useMemoizedFn, useDebounceFn } from 'ahooks';
import { isNil, isNull, isNumber } from '@uno-next/utils';

interface IQtySelectorProps extends InputNumberProps<number> {}

const QtySelector = (props: IQtySelectorProps, ref: ForwardedRef<HTMLInputElement>) => {
  const {
    className,
    min = 1,
    max,
    defaultValue,
    controls = false,
    value: val,
    onChange,
    ...rest
  } = props;
  const [value, setValue] = useState<number | undefined>(
    typeof val === 'number' ? val : defaultValue
  );

  const checkValue = (v: number | undefined): v is number => {
    if (v === null || v === undefined) {
      return false;
    }

    return (isNumber(min) && v < min) || (isNumber(max) && v > max) ? false : true;
  };

  const { run: onChangeHandler } = useDebounceFn<Required<InputNumberProps<number>>['onChange']>(
    v => {
      const count = v ?? 0;

      if (!checkValue(count)) {
        return;
      }

      if (isNull(v)) {
        onChange?.(v);
        return;
      }
      setValue(v);
      onChange?.(v);
    },
    { wait: 300 }
  );

  const onChangeMinus = useMemoizedFn(() => {
    if (!checkValue(value)) {
      return;
    }
    console.log('大大d');
    // if (value === undefined || value === null || value <= min) {
    //   return;
    // }
    setValue(value - 1);
    onChangeHandler(value - 1);
  });

  const onChangePlus = useMemoizedFn(() => {
    if (!checkValue(value)) {
      return;
    }

    setValue((value || 0) + 1);
    onChangeHandler((value || 0) + 1);
  });

  return (
    <InputNumber
      addonBefore={
        <Button
          type="text"
          className={classes.minus}
          disabled={isNumber(min) ? value === undefined || value <= min : false}
          onClick={onChangeMinus}>
          -
        </Button>
      }
      value={value}
      controls={controls}
      min={min}
      onChange={onChangeHandler}
      addonAfter={
        <Button
          className={classes.plus}
          disabled={max !== undefined && (value === undefined || value >= max)}
          type="text"
          onClick={onChangePlus}>
          +
        </Button>
      }
      ref={ref}
      className={classes.wrap}
      {...rest}
    />
  );
};

export default forwardRef(QtySelector);
